import { render, staticRenderFns } from "./CollapseTransition.vue?vue&type=template&id=26b5c9fe&scoped=true"
import script from "./CollapseTransition.vue?vue&type=script&lang=ts"
export * from "./CollapseTransition.vue?vue&type=script&lang=ts"
import style0 from "./CollapseTransition.vue?vue&type=style&index=0&id=26b5c9fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b5c9fe",
  null
  
)

export default component.exports